import { render } from "./SettingMenu.vue?vue&type=template&id=5439bcb6"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__